import React from "react";

export function FirmwareProgressBar({state, tar, rec}) {

    const percentage = Math.round(((rec * 100) / tar), 0)
    const barWidth = rec < tar ? `${percentage}%` : '100%'

    const barColor = "border-danger"

    return <>
        <div className="d-flex justify-content-center align-items-center my-2 w-100">
            <div className="w-100 mx-2">
                <div className="d-flex flex-column gap-2">
                    <div className="d-flex align-items-center">
                        <div>{percentage} %</div>
                    </div>

                    <div className="w-100 position-relative" style={{height: '30px'}}>
                        {/* Full bar in secondary color */}
                        <div
                            className="border-bottom border-5 border-light-subtle "
                            style={{
                                width: '100%',
                                position: 'absolute',
                            }}
                        />

                        {/* Progress bar colored */}
                        <div
                            className={`border-bottom border-5 ${barColor}`}
                            style={{
                                width: barWidth,
                                position: 'absolute',
                                transition: 'width 0.3s ease'
                            }}
                        />
                    </div>

                </div>
            </div>
        </div>
    </>
}